import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({ $licenceExpired: 'licenceExpired' })
  },
  methods: {}
}
